module.exports = __webpack_public_path__ + "img/pro_three_6.d67fd054.jpg";